import "./App.css";
import Contact from "./components/contact/Contact";
import Home from "./components/home/Home";
import Portfolio from "./components/portfolio/Portfolio";

function App() {
  return (
    <>
      <Home />
      <Portfolio />
      <Contact />
    </>
  );
}

export default App;
